import { render, staticRenderFns } from "./PccOrderCargoPropertiesEdit.vue?vue&type=template&id=1b036325&scoped=true&"
import script from "./PccOrderCargoPropertiesEdit.vue?vue&type=script&lang=js&"
export * from "./PccOrderCargoPropertiesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b036325",
  null
  
)

export default component.exports